export default "__VITE_ASSET__dnRHHrMn__"